import { Configuration } from '@ra-state';
import { ENV_VARS, getEnvOrDefault } from '@shared/env';

const appConfiguration: Configuration = {
  production: false,
  name: 'Common Admin',
  csApiBaseUrl: getEnvOrDefault(ENV_VARS.CS_API_BASE_URL, 'https://common.cloud-dev.rockwellautomation.com/api'),
  csPortalUrl: 'https://home.cloud-dev.rockwellautomation.com',
  notificationsBaseUrl: getEnvOrDefault(
    ENV_VARS.CS_NOTIFICATIONS_BASE_URL,
    'https://api-notifications.cloud-dev.rockwellautomation.com',
  ),
  authConfig: {
    domain: 'factorytalkhub-qa.us.auth0.com',
    clientId: 'rrMuRGFLfwh2OlZ2DTtFQ2CGPZLatFqZ',
    audience: 'https://lemans.common',
    scope: 'openid profile email offline_access',
    redirectUri: 'https://common-admin.cloud-dev.rockwellautomation.com/callback',
    connection: 'Rockwell-SP-Admin',
    errorPath: '/sign-in',
    useRefreshTokens: true,
    useMrrt: true,
    cacheLocation: 'localstorage',
  },
  returnToAfterLogout: 'https://common-admin.cloud-dev.rockwellautomation.com/sign-in',
  customSignInUrl: 'https://common-admin.cloud-dev.rockwellautomation.com/sign-in',
  adminPortalURL: 'https://common-admin.cloud-dev.rockwellautomation.com',
};

export const environment = {
  production: false,
  appConfiguration,
  ftHubPortalUrl: 'https://home.cloud-dev.rockwellautomation.com',
};
